// Example component demonstrating organization switching functionality
import { useIdentity } from '@flik/shared';
import React from 'react';

const OrganizationSwitcher: React.FC = () => {
  const {
    currentOrganization,
    availableOrganizations,
    switchOrganization,
    removeOrganization,
    isLoggedIn,
  } = useIdentity();

  if (!isLoggedIn || availableOrganizations.length === 0) {
    return null;
  }

  const handleOrganizationSwitch = (orgId: string) => {
    switchOrganization(orgId);
  };

  const handleRemoveOrganization = (orgId: string) => {
    if (window.confirm('Are you sure you want to remove this organization?')) {
      removeOrganization(orgId);
    }
  };

  return (
    <div className="p-5 border border-gray-300 rounded-lg my-5">
      <h3 className="text-lg font-semibold mb-4">Switch Organization</h3>

      <div className="mb-5 p-2.5 bg-gray-100 rounded">
        <strong>Current Organization:</strong> {currentOrganization || 'None'}
      </div>

      <div>
        <h4 className="text-md font-medium mb-3">Available Organizations:</h4>
        {availableOrganizations.map((org) => (
          <div
            key={org.organization_id}
            className={`flex justify-between items-center p-2.5 my-1 border rounded ${
              org.organization_id === currentOrganization
                ? 'bg-blue-50 border-blue-500'
                : 'border-gray-200'
            }`}
          >
            <div className="flex flex-col">
              <span className="font-bold">
                {org.organization_name || org.organization_id}
              </span>
              <span className="text-sm text-gray-600">
                ({org.organization_id})
              </span>
            </div>

            <div className="flex gap-2.5">
              {org.organization_id !== currentOrganization && (
                <button
                  onClick={() => handleOrganizationSwitch(org.organization_id)}
                  className="px-2.5 py-1.5 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                >
                  Switch
                </button>
              )}

              <button
                onClick={() => handleRemoveOrganization(org.organization_id)}
                className="px-2.5 py-1.5 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrganizationSwitcher;
